<template>
    <div class="container">
        <canvas ref="canvas" width="900" height="500"></canvas>
    </div>
</template>
<script>

    //import VueCharts from 'vue-chartjs'
    import { Pie, mixins } from 'vue-chartjs'
    import ChartDataLabels from 'chartjs-plugin-labels';
    import chroma from "chroma-js";

    export default {
        name: 'Widget',
        extends: Pie,
        props: ['dataset','labels','options','chartData'],
        mixins: [mixins.reactiveProp],
        data () {
            return {
                colors: [
                    'rgba(18, 183, 151, #)',
                    'rgba(18, 161, 253, #)',
                    'rgba(44, 156, 169, #)',
                    'rgba(1, 240, 170, #)',
                    'rgba(247, 0, 65, #)',
                    'rgba(187, 1, 240, #)',
                    'rgba(1, 170, 240, #)',
                    'rgba(1, 240, 170, #)'
                ]
            }
        },
        mounted: function(){

            this.addPlugin(ChartDataLabels);
            this.renderViewChart()

        },
        methods: {
            renderColors: function(count)
            {
              let colors = window.chartColors(count);

              let backgroundColors = [];
              let hoverBackgroundColors = [];

              for(let i=0 ; i<colors.length ; i++)
              {

                var c = 'rgba(' + chroma(colors[i]).rgb().join(',') + ', #)';

                var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 400, 0, 100)
                gradient.addColorStop(0, c.replace('#', 0.4))
                gradient.addColorStop(1, c.replace('#', 0.7))

                backgroundColors.push(gradient);
                hoverBackgroundColors.push(colors[i]);
              }

              return {backgroundColors:backgroundColors, hoverBackgroundColors:hoverBackgroundColors}
            },
            renderViewChart: function()
            {

                let self = this;

                this.renderChart({
                    labels: this.labels,
                    datasets: [{
                        label: this.dataset.label,
                        data: this.dataset.data,
                        backgroundColor: self.renderColors(this.labels.length).backgroundColors,
                        hoverBackgroundColor: self.renderColors(this.labels.length).hoverBackgroundColors,
                        borderWidth: 2
                    }]
                }, this.options);
            }
        },
        watch: {
            dataset () {
                this.renderViewChart()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/chart/Pie.vue